"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressBalanceResponseStxToJSON = exports.AddressBalanceResponseStxFromJSONTyped = exports.AddressBalanceResponseStxFromJSON = void 0;
function AddressBalanceResponseStxFromJSON(json) {
    return AddressBalanceResponseStxFromJSONTyped(json, false);
}
exports.AddressBalanceResponseStxFromJSON = AddressBalanceResponseStxFromJSON;
function AddressBalanceResponseStxFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'balance': json['balance'],
        'total_sent': json['total_sent'],
        'total_received': json['total_received'],
        'total_fees_sent': json['total_fees_sent'],
        'total_miner_rewards_received': json['total_miner_rewards_received'],
        'lock_tx_id': json['lock_tx_id'],
        'locked': json['locked'],
        'lock_height': json['lock_height'],
        'burnchain_lock_height': json['burnchain_lock_height'],
        'burnchain_unlock_height': json['burnchain_unlock_height'],
    };
}
exports.AddressBalanceResponseStxFromJSONTyped = AddressBalanceResponseStxFromJSONTyped;
function AddressBalanceResponseStxToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'balance': value.balance,
        'total_sent': value.total_sent,
        'total_received': value.total_received,
        'total_fees_sent': value.total_fees_sent,
        'total_miner_rewards_received': value.total_miner_rewards_received,
        'lock_tx_id': value.lock_tx_id,
        'locked': value.locked,
        'lock_height': value.lock_height,
        'burnchain_lock_height': value.burnchain_lock_height,
        'burnchain_unlock_height': value.burnchain_unlock_height,
    };
}
exports.AddressBalanceResponseStxToJSON = AddressBalanceResponseStxToJSON;
//# sourceMappingURL=AddressBalanceResponseStx.js.map